import {
  DietaryOptionTypeSchema,
  type DietaryOptionType as GeneratedDietaryOptionType
} from '~/services/api/generated'

// Mirrors backend App\Enums\DietaryOptionType

export type DietaryOptionType = GeneratedDietaryOptionType

export const DietaryOptionType = {
  RESTRICTION: DietaryOptionTypeSchema.enum.restriction,
  PREFERENCE: DietaryOptionTypeSchema.enum.preference,
  ALLERGY: DietaryOptionTypeSchema.enum.allergy
} satisfies Record<string, GeneratedDietaryOptionType>

export const DietaryOptionTypeValues: readonly GeneratedDietaryOptionType[] = [
  DietaryOptionTypeSchema.enum.restriction,
  DietaryOptionTypeSchema.enum.preference,
  DietaryOptionTypeSchema.enum.allergy
]
